import script from "./AppTime.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTime.vue?vue&type=script&setup=true&lang=js"

import "./AppTime.vue?vue&type=style&index=0&id=3502e103&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3502e103"]])

export default __exports__